export default "__VITE_ASSET__CmL3z8DB__"